/* 
  We need to typeguard our errors so that we can safely tell
  error libs like Rollbar.js what type the error is. Typescript only lets us
  use any or unknown, and Javascript is insane, so here is a solution.
*/
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return String(error);
}

export function writeErrorMessage(message: string) {
  console.error('\x1b[30m\x1b[41m%s\x1b[0m', message);
}

export function getErrorObject(error: unknown): Error | string {
  if (error instanceof Error) return error;
  else return 'error was not an instance of Error';
}

/**
 * RTK Query rejects with a serialized `{ status, data }` object rather than an
 * Error, which `getErrorMessage` would reduce to "[object Object]".
 */
export function getQueryErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (error && typeof error === 'object') return JSON.stringify(error);
  return String(error);
}
